import React, { createContext, useContext, useState, useEffect } from "react";
import { languages, getTranslation } from "./i18n";

interface LanguageContextType {
  lang: string;
  t: (key: string) => string;
  setLang: (lang: string) => void;
  dir: string;
}

const LanguageContext = createContext<LanguageContextType>({
  lang: "en",
  t: (key) => key,
  setLang: () => {},
  dir: "ltr"
});

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("mouna_lang") || "en");

  const dir = languages[lang as keyof typeof languages]?.dir || "ltr";

  function setLang(newLang: string) {
    setLangState(newLang);
    localStorage.setItem("mouna_lang", newLang);
    document.documentElement.dir = languages[newLang as keyof typeof languages]?.dir || "ltr";
    document.documentElement.lang = newLang;
  }

  useEffect(() => {
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
  }, []);

  const translations = getTranslation(lang);

  function t(key: string): string {
    return translations[key] || key;
  }

  return (
    <LanguageContext.Provider value={{ lang, t, setLang, dir }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
